export default {
  G_LOADING: state => {
    return state.IS_LOADING
  },
}
